var map = {
	"./Article": 30829,
	"./Article/": 30829,
	"./Article/index": 30829,
	"./Article/index.jsx": 30829,
	"./Article/styles.module.css": 50574,
	"./FooterLayout": 93444,
	"./FooterLayout/": 93444,
	"./FooterLayout/index": 93444,
	"./FooterLayout/index.jsx": 93444,
	"./FooterLayout/styles.module.css": 42113,
	"./HeroLayout": 34142,
	"./HeroLayout/": 34142,
	"./HeroLayout/index": 34142,
	"./HeroLayout/index.jsx": 34142,
	"./HeroLayout/styles.module.css": 42803,
	"./ProductsLayout": 34410,
	"./ProductsLayout/": 34410,
	"./ProductsLayout/index": 34410,
	"./ProductsLayout/index.jsx": 34410,
	"./ProductsLayout/styles.module.css": 90105,
	"./QuoteLayout": 31419,
	"./QuoteLayout/": 31419,
	"./QuoteLayout/index": 31419,
	"./QuoteLayout/index.jsx": 31419,
	"./QuoteLayout/styles.module.css": 54358,
	"./TestimonialsLayout": 1459,
	"./TestimonialsLayout/": 1459,
	"./TestimonialsLayout/index": 1459,
	"./TestimonialsLayout/index.jsx": 1459,
	"./TestimonialsLayout/styles.module.css": 96832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;